// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__KF34C","content":"classes_content___Do9G"};